module.exports = __webpack_public_path__ + "img/moon-solid.1f5a7fe9.svg";